<div
  #frame
  id="frame"
  (mousedown)="startPan($event)"
  (mousemove)="pan($event)"
  (mouseup)="endPan()"
  (mouseleave)="endPan()">
  <div #content id="content" [style.transform]="getContentTransform()">
    <irembogov-workflow-state
      class="state-machine"
      *ngFor="let item of workflow.states | keyvalue"
      [config]="item.value"
      [id]="'STATE#' + item.value.displayName"
      cdkDrag
      [cdkDragFreeDragPosition]="item.value.position"
      (cdkDragMoved)="onDragMove()"
      (cdkDragEnded)="onDragEndState($event)">
    </irembogov-workflow-state>

    <irembogov-workflow-transition
      class="state-machine"
      *ngFor="let item of workflow.transitions"
      [config]="item"
      [id]="'TRANSITION#' + item.startState + '#' + item.name"
      cdkDrag
      [cdkDragFreeDragPosition]="item.position"
      (cdkDragMoved)="onDragMove()"
      (cdkDragEnded)="onDragEndTransition($event)"
      (updateTransition)="onUpdateTransition($event)">
    </irembogov-workflow-transition>
  </div>
  <div #linesWrapper id="leader-line-container"></div>
</div>
